<template>
  <section class="premium-box">
    <h3>Premium</h3>
    <div class="box ">
      <div class="">
        <el-form
          ref="premiumForm"
          :model="formData"
          :disabled="disabled"
          :rules="rules">
          <div class="table">
            <div
              v-for="(item,index) in list"
              :key="index"
              :class="item.style==5&&item.name=='total_mul'?'style-2':`style-${item.style}`"
              class="tr">
              <span> {{ item.item }}</span>
              <!--              <span-->
              <!--                v-if="item.name=='basic_prm' && item.min_base_prm"-->
              <!--                class="min">(Min. {{ item.min_base_prm}})</span>-->
              <span
                v-if="item.name=='basic_prm' && item.min_base_prm"
                class="flex flex-center mg-r-0">
                <v-checkbox
                  v-model="formData.min_charge_allow"
                  :is-boolean="false"
                  @change="handlerComputed"></v-checkbox>
                <span
                  class="min mg-l-5">(Min. {{ item.min_base_prm}})</span>
              </span>
              <div class="flex flex-algin right">
                <span
                  v-if="[1,2,6].includes(item.style)||item.style==5&&item.name=='total_mul'&&productId==11"
                  class="">
                  <el-form-item
                    :prop="item.style==2||item.style==5&&item.name=='total_mul'&&productId==11?(item.name+'_pct'):item.name">
                    <v-input
                      v-if="[1,6].includes(item.style)"
                      v-model="formData[item.name]"
                      prepend="$"
                      :keyFloatNumber="true"
                      :disabled="item.style==6"
                      :negativeNumber="item.negative === 1"
                      maxlength="8"
                      @blur="handlerComputed"
                    />
                    <v-input
                      v-if="item.style==2||item.style==5&&item.name=='total_mul'&&productId==11"
                      v-model="formData[item.name+'_pct']"
                      append="%"
                      :keyFloatNumber="true"
                      :negativeNumber="item.negative === 1"
                      maxlength="8"
                      @blur="handlerComputed"
                    />
                  </el-form-item>
                </span>
                <span
                  v-if="item.style==5&&item.name!='total_mul'"
                  class="">
                  <el-form-item
                    :prop="item.name2">
                    <v-input
                      v-model="formData[item.name][item.name2]"
                      prepend="$"
                      :keyFloatNumber="true"
                      :negativeNumber="item.negative === 1"
                      maxlength="8"
                      :disabled="unSelectKeys.includes(item.name2) || (item.id && !benefitList.includes(item.id))"
                      @blur="handlerComputed"
                    />
                  </el-form-item>
                </span>
                <span
                  v-if="item.style==2||item.style==5&&item.name=='total_mul'&&productId==11"
                  class="right-width">{{ formData[item.name + '_amt'] | formatMoney(2, true) }}</span>
                <span
                  v-if="item.style==3"
                  class="">{{ formData[item.name + '_vl']| formatMoney(2, true) }}</span>
                <span
                  v-if="item.style==4"
                  class="span-right total">{{ formData[item.name] | formatMoney(2, true) }}</span>
              </div>
            </div>

            <div
              v-if="[11,12,13,14,15].includes(classId)"
              class="tr">
              <span>MIB</span>
              <span>
                <el-form-item prop="mib_pct">
                  <v-input
                    v-model="formData.mib_pct"
                    append="%"
                    :keyFloatNumber="true"
                    maxlength="8"
                    @blur="handlerComputed"
                  />
                </el-form-item>
              </span>
              <span class="right"> {{ formData.mib_vl| formatMoney(2, true) }}</span>
            </div>
            <div
              v-if="classId==21||classId==26"
              class="tr style-1">
              <span> EC Levy</span>
              <div class="flex flex-algin right">
                <span class="">
                  <el-form-item
                    prop="ev_levy_vl">
                    <v-input
                      v-model.number="formData.ec_levy_vl"
                      prepend="$"
                      :keyFloatNumber="true"
                      maxlength="8"
                      @blur="handlerComputed"
                    />
                  </el-form-item>
                </span>
              </div>
            </div>
            <div
              v-if="classId==24"
              class="tr">
              <span>EC Levy</span>
              <span>
                <el-form-item prop="ec_levy_pct">
                  <v-input
                    v-model="formData.ec_levy_pct"
                    append="%"
                    :keyFloatNumber="true"
                    maxlength="8"
                    @blur="handlerComputed"
                  />
                </el-form-item>
              </span>
              <span class="right"> {{ formData.ec_levy_vl| formatMoney(2, true) }}</span>
            </div>
            <div
              class="tr">
              <span>IA Levy</span>
              <span>
                <el-form-item prop="ia_levy_pct">
                  <v-input
                    v-model="formData.ia_levy_pct"
                    append="%"
                    :keyFloatNumber="true"
                    maxlength="8"
                    @blur="handlerComputed"
                  />
                </el-form-item>
              </span>
              <span class="right"> {{ formData.ia_levy_vl| formatMoney(2, true) }}</span>
            </div>
            <div class="tr style-4">
              <span>Gross Premium</span>
              <span class="total">{{formData.gross | formatMoney(2, true)}}</span>
            </div>


            <!-- discount -->
            <div
              v-if="referrer_is_special"
              class="tr">
              <span>Referral Discount</span>
              <el-form-item prop="spec_disc_prm">
                <span>
                  <v-input
                    v-model.number="formData.code_disc_prm"
                    prepend="-$"
                    :keyFloatNumber="true"
                    maxlength="8"
                    :max="max_code_disc_prm"
                    :min="0"
                    @blur="handlerComputed"></v-input>
                </span>
              </el-form-item>
            </div>
            <div
              class="tr">
              <span>Coupon Discount</span>
              <el-form-item prop="spec_disc_prm">
                <span>
                  <v-input
                    v-model.number="formData.coupon_vl"
                    disabled
                    prepend="-$"
                    :keyFloatNumber="true"
                    maxlength="8"
                    :min="0"
                    @blur="handlerComputed"></v-input>
                </span>
              </el-form-item>
            </div>
            <div
              v-if="editType == 3"
              class="tr">
              <span>Renew Discount <span v-if="formData.is_renew_discount">({{formData.renew_disc_pct}}%)</span></span>
              <el-form-item
                prop="spec_disc_prm"
                class="text-right">
                <div
                  :class="{
                    'flex-sb': formData.is_renew_discount,
                  }">
                  <span v-if="formData.is_renew_discount">{{formData.renew_disc_prm | formatMoney(2, true)}}</span>
                  <div>
                    <span class="mg-r-8">{{formData.is_renew_discount? 'On' : 'Off'}}</span>
                    <el-switch
                      v-model="formData.is_renew_discount"
                      :active-value="1"
                      :inactive-value="0"
                      :disabled="is_renew_disable||isFina"
                      active-color="#409EFF"
                      inactive-color="#AFB8C1"
                      @change="handlerRenew"></el-switch>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div
              class="tr">
              <span>Promo Discount</span>
              <el-form-item prop="spec_disc_prm">
                <span>
                  <v-input
                    v-model.number="formData.promo_disc_prm"
                    prepend="-$"
                    :keyFloatNumber="true"
                    :disabled="editType==3&&formData.is_renew_discount==1"
                    maxlength="8"
                    :min="0"
                    @blur="handlerComputed"></v-input>
                </span>
              </el-form-item>
            </div>
            <div class="tr">
              <span>Manual Discount </span>
              <el-form-item prop="spec_disc_prm">
                <span>
                  <v-input
                    v-model.number="formData.spec_disc_prm"
                    prepend="-$"
                    :keyFloatNumber="true"
                    maxlength="8"
                    :min="0"
                    @blur="handlerComputed"></v-input>
                </span>
              </el-form-item>
            </div>
            <div
              v-if="[11,12,13,14,15].includes(classId)"
              class="tr">
              <span>MIB Discount</span>
              <span>
                <el-form-item prop="mib_disc_prm">
                  <v-input
                    v-model.number="formData.mib_disc_prm"
                    prepend="-$"
                    :keyFloatNumber="true"
                    maxlength="8"
                    :min="0"
                    @blur="handlerComputed"></v-input>
                </el-form-item>
              </span>
            </div>
            <div
              v-if="classId==21||classId==26||classId==24"
              class="tr style-1">
              <span>EC Levy Discount</span>
              <div class="flex flex-algin right">
                <span class="">
                  <el-form-item
                    prop="ec_levy_disc_prm">
                    <v-input
                      v-model.number="formData.ec_levy_disc_prm "
                      prepend="-$"
                      :keyFloatNumber="true"
                      maxlength="8"
                      :min="0"
                      @blur="handlerComputed"
                    />
                  </el-form-item>
                </span>
              </div>
            </div>
            <div
              class="tr">
              <span>IA Levy Discount</span>
              <span>
                <el-form-item prop="ia_levy_disc_prm">
                  <v-input
                    v-model="formData.ia_levy_disc_prm"
                    prepend="-$"
                    :keyFloatNumber="true"
                    maxlength="8"
                    :min="0"
                    @blur="handlerComputed"
                  />
                </el-form-item>
              </span>
            </div>
            <div class="tr">
              <span>Insurer Admin Charge </span>
              <el-form-item prop="insurer_handling_fee">
                <span>
                  <v-input
                    v-model.number="formData.insurer_handling_fee"
                    prepend="+$"
                    :keyFloatNumber="true"
                    maxlength="8"
                    :min="0"
                    @blur="handlerComputed"></v-input>
                </span>
              </el-form-item>
            </div>
            <div class="tr">
              <span>Agency Admin Charge </span>
              <el-form-item prop="agency_handling_fee">
                <span>
                  <v-input
                    v-model.number="formData.agency_handling_fee"
                    prepend="+$"
                    :keyFloatNumber="true"
                    maxlength="8"
                    :min="0"
                    @blur="handlerComputed"></v-input>
                </span>
              </el-form-item>
            </div>
            <div class="tr">
              <span>Admin Charge </span>
              <el-form-item prop="handling_fee">
                <span>
                  <v-input
                    v-model.number="formData.handling_fee"
                    prepend="+$"
                    :keyFloatNumber="true"
                    maxlength="8"
                    :min="0"
                    disabled
                    @blur="handlerComputed"></v-input>
                </span>
              </el-form-item>
            </div>
            <div class="tr style-4">
              <span>Amount</span>
              <span
                class="text-right">{{ formData.main_policy_amount | formatMoney(2, true) }}</span>
            </div>
            <!-- <div
              v-if="productId==11"
              class="tr">
              <span>Surcharge </span>
              <el-form-item prop="surcharge">
                <span>
                  <v-input
                    v-model.number="formData.surcharge"
                    prepend="+$"
                    :keyFloatNumber="true"
                    maxlength="8"
                    :min="0"
                    @blur="handlerComputed"></v-input>
                </span>
              </el-form-item>
            </div> -->
          </div>
        </el-form>
      </div>
    </div>

    <premium-select-code
      ref="select-code"
      :orderId="orderId"
      :notApply="true"
      :isQuote="false"
      :customerId="customerId"
      :classId="class_id"
      :disabled="disabled"
      :customer="customer"
      :form="form"
      :is-renew="editType==3"
      :is-fina="isFina"
      :formDataLock="formDataLock"
      :couponDisabled="formData.is_renew_discount==1&&editType == 3"
      isUser
      @check-code="applyCode"
      @computedCoupon="handleComputedData"
    ></premium-select-code>
    <!--    <div-->
    <!--      v-if="showReferralSelect"-->
    <!--      class="mg-t-20 mg-b-15 flex">-->
    <!--      &lt;!&ndash;      <span class="fs-14 color-dark fw-600 title margin-left">Referrer Discount</span>&ndash;&gt;-->
    <!--      <v-select-->
    <!--        v-model="referral_id"-->
    <!--        :list="referral_option_list"-->
    <!--        @change="handlerComputed"></v-select>-->
    <!--      <v-button-->
    <!--        gray-->
    <!--        class="mg-l-10"-->
    <!--        @click="handleInitRefer">Default</v-button>-->
    <!--    </div>-->
    <!--    <vip-discount-select-->
    <!--      :form="form"-->
    <!--      :renew-order-id="renewOrderId"-->
    <!--      :edit-type="editType"></vip-discount-select>-->

    <!-- extra benefit -->
    <extra-benefits-table
      :selectExtraBenefit="selectExtraBenefit"
      :is-renew="isRenew"
      :extra_benefits="form.extra_benefits"
      :extra_benefits_content="formData.extra_benefits_content"
      @changeData="handlerComputed"></extra-benefits-table>


    <h2 class="mg-t-15">Total Payable</h2>
    <div class="box">
      <div class="table">
        <div class="tr">
          <span>Main Policy</span>
          <div class="flex flex-algin right">
            <span
              class="text-right">{{ formData.main_policy_amount | formatMoney(2, true) }}</span>
          </div>
        </div>
        <template v-for="(item, i) in formData.extra_benefits_content">
          <div
            v-if="form.extra_benefits.includes(item.id)"
            :key="i"
            class="tr">
            <span>{{item.name}}</span>
            <span
              class="text-right">{{ item.content['premium'] | formatMoney(2, true) }}</span>
          </div>
        </template>
        <div class="tr style-4">
          <span>Total Payable</span>
          <span
            class="text-right">{{ formData.payable | formatMoney(2, true) }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MixinFormat from '@/mixins/format'
import MixinReferralOption from '@/mixins/referral-option'
import premiumSelectCode from '@/views/components/premium-select-code'
import {applyOrderCode, getOrderPremiumData} from '@api/order'
import {getReferralMain} from '@api/refer'
import MixinRules from '@/mixins/rules'
import ExtraBenefitsTable from './extra_benefits_table.vue'
import {getRenewMain, getRenewPremiumData} from '@/api/renewal'
import {mapActions} from 'vuex'

export default {
  name: 'premium-form',
  components: {
    premiumSelectCode,
    ExtraBenefitsTable,
  },
  mixins: [MixinFormat, MixinRules,MixinReferralOption],
  props: {
    classId: {
      type: [Number, String],//14 motor 21 domestic 24 decoration 26 home &fire
      default: ''
    },
    planId: {
      type: [Number, String],//14 motor 21 domestic 24 decoration 26 home &fire
      default: ''
    },
    extra_select: {
      type: [Array, String,Object],//14 motor 21 domestic 24 decoration 26 home &fire
      default:()=>[]
    },
    extraData: {
      type: [Array, String,Object],//14 motor 21 domestic 24 decoration 26 home &fire
      default:()=>[]
    },
    customerId: {
      type: [Number, String],
      default: ''
    },
    isShowCode: {
      type: Boolean,
      default: true
    },
    isFina: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    },
    refreshMain: {
      type: Number,
      default: 0
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    modelId:{
      type:[Number,String],
      default:0
    },
    unSelectKeys:{
      type: Array,
      default: () => []
    },
    benefitList:{
      type: Array,
      default: () => []
    },
    selectExtraBenefit:{
      type: Array,
      default: () => []
    },
    editType: {
      type: Number,
      default: 0
    },
    renewOrderId:{
      type: [Number, String],
      default: null
    }
  },
  data() {
    const checkBasePrm = (rule, value, cb) => {
      const noValue = value === '' || value == null || value == undefined
      if(noValue){
        cb(new Error(this.$t('placeholder.input')))
      }
      if(this.editType == 3 && value == 0) {
        cb(new Error('Basic Premium必須大於0'))
      }
      cb()
    }
    const checkNcd = (rule, value, cb) => {
      const noValue = value === '' || value == null || value == undefined
      if(noValue){
        cb(new Error(this.$t('placeholder.input')))
      }
      if(this.editType == 3 && value >= 100) {
        cb(new Error('NCD必須細於100'))
      }
      cb()
    }
    return {
      premium: [],
      extraBenefitSelect:[],
      oldFormDataLock: -1,
      // extraBenefitSelect:[],
      benefits_content:[],
      selectCode:{},
      formData: {
        handling_fee: 0,
        agency_handling_fee: 0,
        insurer_handling_fee: 0,
        surcharge:0,
        spec_disc_prm: 0,
        promo_disc_prm: 0,
        coupon_vl: 0,
        coupon_code: '',
        code_disc_prm: 0,
        code: '',
        code_disc_pct: 0,
        basic_prm: 0,
        base_prm: 0,
        // loading_base_pct:'',
        payable: 0,
        mib_vl: 0,
        mib_pct: 0,
        ia_levy_pct: 0,
        ia_levy_vl: 0,
        ec_levy_vl: 0,
        ia_levy_disc_prm: 0,
        mib_disc_prm: 0,
        ec_levy_disc_prm: 0,
        plan_type:'',
        benefit_premium:'',
        extra_benefits_content:[],
        min_premium: '',
        gross: 0,
        main_policy_amount: 0,
        total_mul_amt: 0,
        total_mul_pct: 0,
        chooseCode: false,
        chooseCoupon: false,
        is_renew_discount: 1,
        renew_disc_prm: '',
        renew_disc_pct: '',
        min_charge_allow:1,
        referrer_is_special:false,
        max_code_disc_prm:0
      },
      extraRules:{
        base_prm: [
          { validator: checkBasePrm, trigger: ['change', 'blur'] },
        ],
        cfd_pct: [
          { validator: checkNcd, trigger: ['change', 'blur'] },
        ],
      },
    }
  },
  computed: {
    isRenew(){
      return this.editType==3
    },
    isNewQuote(){
      let {type} = this.form
      return false
    },
    referrer_is_special(){
      let {referrer_is_special=false} = this.formData||{}
      return referrer_is_special
    },
    max_code_disc_prm(){
      let {max_code_disc_prm} = this.formData||{}
      return max_code_disc_prm
    },
    isRefer(){
      return true
    },
    orderId() {
      let {order_id} = this.$route.query||{}
      return order_id || ''
    },
    company_id() {
      let {company_id} = this.form
      return company_id || ''
    },
    class_id() {
      let {class_id} = this.form
      return class_id || ''
    },
    is_renew_disable() {
      let {is_renew_disable=0} = this.form
      return is_renew_disable==1
    },
    productId () {
      let {product_id} = this.form
      return product_id || ''
    },
    customer() {
      let {isrd_nm} = this.form || {}
      return {
        isrd_nm
      }
    },
    list() {
      let data = this.premium.filter(item => {
        // if(this.classId==24)
        return item.item != 'EC Levy' && item.item != 'IA Levy' && item.item != 'MIB'
        // else   return item.item!='IA Levy'&&item.item!='MIB'
      })
      return data || []
    },
    ecList() {
      let data = this.premium.filter(item => {
        // if(this.classId==24)
        return item.item == 'MIB' || item.item == 'EC Levy' || item.item == 'IA Levy'
        // else return item.item=='MIB'||item.item=='IA Levy'
      })
      return data || []
    },
    premiumFormKey() {
      const result = this.premium.reduce((result, item) => {
        const { name, style,name2 } = item
        if(style == 2||style==5&&name=='total_mul'&&this.productId==11) {
          result.push(`${name}_amt`)
          result.push(`${name}_pct`)
        }
        if(style == 3) {
          result.push(`${name}_vl`)
        }
        if(style == 5&&name!='total_mul') {
          result.push({style:5,name,name2})
        }
        else {
          result.push(name)
        }
        return result
      }, [])
      return result
    },
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      immediate:true,
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
          if([11,12,14].includes(this.classId))
          {
            let {company_id,plan_id,refer_id} = this.form||{}
            if(company_id&&plan_id)
            {
              let params = {
                class_id:this.classId,
                company_id,
                plan_id,
                refer_id,
                order_id: this.renewOrderId
              }
              this.network().getOrderPremiumData(params)
            }
          }
        }
      }
    },
    'form.plan_id': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val && this.formDataLock !== this.oldFormDataLock) {
          this.oldFormDataLock = this.formDataLock
          let {company_id, plan_id, refer_id} = this.form || {}
          let params = {
            class_id: this.classId,
            company_id,
            plan_id,
            refer_id,
            order_id: this.renewOrderId
          }
          this.network().getOrderPremiumData(params)

          // this.premiumFormKey.some(item => {
          //   this.$set(this.formData, item, this.form[item] || 0)
          // })
        }
      }
    },
    planId: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val && this.formDataLock !== this.oldFormDataLock) {
          this.oldFormDataLock = this.formDataLock
          let {company_id, plan_id, refer_id} = this.form || {}
          let params = {
            class_id: this.classId,
            company_id,
            plan_id,
            refer_id,
            order_id: this.renewOrderId
          }
          this.network().getOrderPremiumData(params)

          // this.premiumFormKey.some(item => {
          //   this.$set(this.formData, item, this.form[item] || 0)
          // })
        }
      }
    },
    'form.extra_benefits': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          this.handlerInitExtra()
        }
      }
    },
    // 'form.extra_benefits_content': {
    //   immediate: true,
    //   deep: true,
    //   handler(val) {
    //     if(val) {
    //       this.handlerInitExtra()
    //     }
    //   }
    // },
    benefitList:{
      immediate: true,
      deep: true,
      handler(val){
        // console.log(val)
      }
    },
    premiumFormKey: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val && val.length > 0) {
          // this.handlerInitPremium()
          // val.some(item => {
          //   this.$set(this.formData, item, this.form[item] || 0)
          // })
        }
      }
    },
    refreshMain:{
      immediate:true,
      handler(val){
        if (val>0){
          this.network().getReferralMain()
        }
      }
    },

    unSelectKeys:{
      immediate: true,
      deep: true,
      handler(val){
        if(val.length && (this.classId == 11 || this.classId == 12)){
          if(typeof(this.formData['benefit_premium']) == 'object'){
            val.map(item => {
              this.formData['benefit_premium'][item] = 0
            })
          }
        }
      }
    },

    'formData.benefit_premium':{
      immediate: true,
      deep: true,
      handler(val){
        if(JSON.stringify(val) == JSON.stringify([])){
          this.formData.benefit_premium = {}
        }
      }
    },
    form:{
      immediate:true,
      handler(val){
        let {is_renew_discount,min_charge_allow} = val||{}
        if(is_renew_discount==0||is_renew_discount==1)
          this.formData.is_renew_discount = is_renew_discount
        if(min_charge_allow==0||min_charge_allow==1)
          this.formData.min_charge_allow = min_charge_allow
      }
    }
  },
  created(){

  },
  methods: {
    ...mapActions('renewal', ['setRenewSendData']),
    handleInitRefer(){
      this.initReferrerId()
      this.handlerComputed()
    },
    handlerInitExtra(){
      let data = this.form||{}
      let {extra_benefits_content={},extra_benefits} =data
      if(extra_benefits_content)
      {
        let extra_benefits_content_arr =  Object.entries(extra_benefits_content).map(item=>item[1])
        extra_benefits_content_arr = extra_benefits_content_arr.filter(item=>{
          return extra_benefits.includes(Number(item.id))
        })
        this.formData.extra_benefits_content = extra_benefits_content_arr||[]
      }
    },
    handlerInitPremium() {
      Object.keys(this.formData).some(key => {
        if(key in this.form) {
          const value = this.form[key]||this.formData[key] || 0
          if(key=='benefit_premium'){
            this.formData[key] = {}
            Object.keys(value).filter(item=>{
              value[item] = value[item]||''
            })
            this.formData[key] =value ||{}
          }
          if(key=='extra_benefits_content'){
            this.handlerInitExtra()
          }
          else{
            this.formData[key] = value || 0
          }
        }
      })
      this.premiumFormKey.some(key => {
        if(key.style==5&&key.name!='total_mul')
        {
          let {name2,name} = key||{}
          const value =  this.formData[name] || this.form[name]||{}
          this.formData[name]  ={}
          let params = value[name2]||0
          this.formData[name][name2] =params
          Object.keys(value).filter(item=>{
            value[item] = value[item]||0
          })
          this.formData[name] =value ||{}
        }
        else
        {
          const value = this.formData[key] || this.form[key]
          this.$set(this.formData, key, value || 0)
        }
      })
      if(this.productId==14&&this.editType==3&&this.index==0){
        this.handlerComputed()
      }

    },
    submitForm(formName) {
      let {extra_benefits = []} = this.form||{}
      let params = {
        ...this.formData,
        // ...this.code_discount_info,
        extra_benefits:extra_benefits,
      }
      this.$refs['premiumForm'].validate((valid, rules) => {
        if (valid)
          this.$emit('submitPremium', 'premium', params, this.index)
        // this.network().getReferralMain({},formName)
      })
    },
    handlerRenew(){
      let {is_renew_discount} =this.formData
      if(is_renew_discount==1)
      {
        this.selectCode.coupon = {}
      }
      this.handlerComputed()
    },
    handlerComputed(v) {
      if(this.isFina){
        this.handleComputedData()
      }else
      {
        if(v){
          setTimeout(() => {
            this.$refs['select-code'].handleComputedData()
          },500)
        }else{
          this.$refs['select-code'].handleComputedData()
        }
      }
    },
    handleComputedData(data){
      this.selectCode = data
      this.$refs['premiumForm'].validate((valid, rules) => {
        if (valid) {
          this.chooseCode = false
          this.chooseCoupon = false
          this.network().getReferralMain()
        }
      })
    },
    applyCode(data) {
      this.selectCode = data
      // 选择优惠券或者优惠码后，该次发起的请求对应的值需要传null
      if(data.code){
        this.chooseCode = true
      }
      if(data.coupon){
        this.chooseCoupon = true
      }
      this.network().getReferralMain({},'',true)
    },
    network() {
      return {
        //初始化数据
        getOrderPremiumData: async (params) => {
          if(this.editType == 3){
            var {data} = await getRenewPremiumData(params)
          }else{
            var {data} = await getOrderPremiumData(params)
          }
          this.premium = data
          this.handlerInitPremium()
        },
        getReferralMain: async (params, formName,isRefer=false) => {
          let premiumParams = {
            class_id: this.classId,
            company_id: this.form.company_id,
            plan_id: this.form.plan_id,
            refer_id: this.form.refer_id,
            order_id: this.renewOrderId
          }
          await getOrderPremiumData(premiumParams)
          if(!this.formData.extra_benefits_content || this.formData.extra_benefits_content.length == 0){
            this.formData.extra_benefits_content = this.selectExtraBenefit
          }
          let {refer_id, trm_of_cvr, company_id, plan_id,extra_benefits,excess={}, quote_status} = this.form
          let {coupon, code,is_campaign_code} = this.selectCode || {}
          let select = {}
          if(!this.isFina){
            select.coupon_code = coupon&&coupon.coupon_code||''
            select.code = code&&code.code||''
            console.log('is_campaign_code--',is_campaign_code)
            if(is_campaign_code){
              select.campaign_code = coupon&&coupon.coupon_code
              delete select.coupon_code
            }
          }
          if(this.chooseCoupon){
            this.formData.coupon_vl = null
          }
          if(this.chooseCode){
            this.formData.code_disc_pct = null
            this.formData.code_disc_prm = null
          }
          let extra_params = {}
          params = {...params}
          // 没有选公司或者选了拒绝就不请求
          if(!company_id || quote_status == 0){
            return
          }
          // console.log(this.benefitList)
          this.formData.benefits = JSON.parse(JSON.stringify(this.benefitList))
          if(this.classId==11){
            extra_params ={
              extra_benefits,
            }
            params.model_id = this.modelId
          }
          if(this.productId==11){
            params = {...params,...excess}
          }
          if(this.formData.benefit_premium == 0)this.formData.benefit_premium ={}
          params.merchant_platform = 1
          if(this.isFina){
            delete this.formData.customer_id
            params.merchant_platform = 2
          }
          if(this.editType == 3){
            var {data} = await getRenewMain({
              order_id: this.renewOrderId,
              trm_of_cvr,
              company_id,
              plan_id,
              class_id: this.classId,
              ...this.formData,
              ...params,
              ...extra_params,
              ...select
            })
          }else{
            var {data} = await getReferralMain({
              refer_id,
              trm_of_cvr,
              company_id,
              plan_id,
              class_id: this.classId,
              ...this.formData,
              ...params,
              ...extra_params,
              ...select
            })
          }
          // data.extra_benefits_content = this.formData.extra_benefits_content
          this.formData.special_clause = null
          Object.assign(this.formData, data)
          this.formData.handling_fee = data.handling_fee
          Object.keys(this.formData).some(key => {
            if (key in data) {
              if(key=='extra_benefits_content')
              {
                this.formData.extra_benefits_content =  data.extra_benefits_content
              }else
                this.formData[key] = data[key]
            }
          })
          let {referrer_is_special,referrer_id} = data||{}
          if(referrer_id<=0)
            this.formData.referrer_is_special = false
          let paramsChange ={
            ... this.formData,...extra_params,
            // ...this.code_discount_info,
            unSelectKeys: this.unSelectKeys,
            ...select,
          }
          if(data.renew_discount_reply_data){
            this.setRenewSendData(data.renew_discount_reply_data)
          }
          // if(isRefer)
          // {
          //   // let orderId = this.editType==3?this.renewOrderId:this.orderId
          //   // let {quo_id=''} = this.form||''
          //   // this.mixinNetwork().getOrderReferralList({order_id:orderId,code:select.code,quo_id})
          // }
          this.$emit('getSubmitPremium',paramsChange, this.index)
        },
        applyOrderCode: async () => {
          let {selectCode, coupon, code,is_campaign_code} = this.selectCode || {}
          let params = {}
          params.coupon = coupon&&coupon.coupon_code
          params.code = code&&code.code
          params = {
            ...params,
            // ...this.code_discount_info
          }
          if(is_campaign_code){
            delete params.code
          }
          const {data} = await applyOrderCode({
            order_id: this.orderId,
            customer_id: this.customerId,
            class_Id: this.classId,
            ...params
          })
          this.network().getReferralMain({},'',true)
          // this.formData = Object.assign(this.formData, dataCode)
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.premium-box {
  width: 345px;
  //width: 500px;
  margin-bottom: 24px;

  .box {
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #E1E4E8;
    border-radius: 8px;
    background-color: #FFFFFF;

    .table {
      margin-bottom: 0;

      .tr {
        //padding: 16px;
        height: 64px;
        padding: 0 16px;
        color: #586069;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        align-items: center;
        justify-content: space-between;

        &:last-child {
          border-bottom: 0;
        }

        > span {
          flex: 2;
        }

        > div {
          flex: 2
        }
        .text-right{
          text-align: right;
        }
        .mg-r-8{
          margin-right: 8px;
        }
      }

      .tr:nth-child(2n) {
        background: none;
      }

      .tr:first-child{
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }
      .tr:last-child{
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }

      .style-2 {
        ::v-deep .el-input {
          width: 100px;
        }
      }

      .style-4 {
        background-color: #F6F8FA !important;

        .span-right {
          color: #24292E;
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 0;
          line-height: 16px;
        }
        .min{
          text-align: center;
          color: #000;
        }
        .total{
          text-align: right;
          color: #000;
        }
      }

      .right {
        text-align: right;
        margin-left: 16px;
        //width: 80px;
      }

      .right-width {
        width: 69px;
      }

      .flex-algin {
        align-items: center;
        justify-content: flex-end;
      }
    }

  }

  ::v-deep .el-input-group__append {
    padding: 0 5px;
  }
}
.mg-r-0{
  margin-right: 0;
}
</style>
